import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import HeaderEpub from "../../../Components/Header-Epub/Header-Epub";
import ErrorModal from "../../../Components/ErrorModal/ErrorModal";

const CileContentEpubReview = (props) => {

    const [loadingLivros, setLoadingLivros] = useState(true)
    const [livro, setLivro] = useState(null)
    const [loadingGeracao, setLoadingGeracao] = useState(false)
    const [loadingExtracao, setLoadingExtracao] = useState(false)
    const [flagGeracao, setFlagGeracao] = useState(false)
    const [flagExtracao, setFlagExtracao] = useState(false)
    const [modalInfosSuccess, setModalInfosSuccess] = useState(false)
    const [modalReverter, setModalReverter] = useState(false)
    const [loadingReverter, setLoadingReverter] = useState(false)
    const [status, setStatus] = useState(0)
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const bookId = props.match.params.idLivro ? props.match.params.idLivro : ''




    useEffect(() => {
        chamadaLivro()
    }, [])

    const chamadaLivro = () => {
        setLoadingLivros(true)
        const config = new Configurations();
        axios.get(config.apiBasePath + `/conteudo-cile/epub/detalhes-livro/${bookId}`)
            .then(response => {
                setLivro(response.data.dados)
                setLoadingLivros(false)
                setFlagExtracao(response.data.dados.extract_flag)
                setFlagGeracao(response.data.dados.extract_flag)
                setStatus(response.data.dados.approval_status)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {

            });
    }

    const extrairConteudo = () => {
        const config = new Configurations();
        setLoadingExtracao(true)

        axios.post(config.apiBasePath + `/conteudo-cile/epub/extracao-conteudo/${bookId}`, { producao: false })
            .then(response => {
                console.log("RESPONSE DATA: ", response.data)
                setLoadingExtracao(false)
                setFlagExtracao(true)
                setFlagGeracao(true)
                toggleModalInfos()
                setStatus(response.data.approval_status)

            }).catch(error => {
                console.log("ERROR: ", error)
                setLoadingExtracao(false)
                setErrorMessage(error.response.data.message || "Ocorreu um erro ao extrair o conteúdo.");
                toggleErrorModal();
            })
    }

    const gerarLivro = () => {
        const config = new Configurations();
        setLoadingGeracao(true)

        axios.post(config.apiBasePath + `/conteudo-cile/epub/criacao-epub/${bookId}`, { producao: false })
            .then(response => {
                console.log("RESPONSE DATA: ", response.data)
                setLoadingGeracao(false)
                setFlagGeracao(true)
                toggleModalInfos()

            }).catch(error => {
                console.log("ERROR: ", error)
                setLoadingGeracao(false)
                setErrorMessage(error.response.data.message || "Ocorreu um erro ao gerar o EPUB.");
                toggleErrorModal();
            })
    }

    const reverterConteudo = () => {
        const config = new Configurations();
        setLoadingReverter(true)
        toggleModalReverter()

        axios.post(config.apiBasePath + `/conteudo-cile/epub/reverter-conteudo/${bookId}`, { producao: false })
            .then(response => {
                console.log("RESPONSE DATA: ", response.data)
                setLoadingReverter(false)
                setFlagExtracao(false)
                toggleModalInfos()
                chamadaLivro()

            }).catch(error => {
                console.log("ERROR: ", error)
            })
    }



    const toggleErrorModal = () => {
        setOpenErrorModal(!openErrorModal);
    }

    const toggleModalInfos = () => setModalInfosSuccess(!modalInfosSuccess);
    const toggleModalReverter = () => setModalReverter(!modalReverter);

    return (
        <div className="cile-remessas">
            <div className="row">
                {loadingLivros ? null
                    :
                    (
                        <HeaderEpub
                            pageTitle="CILE - Revisar EPUB"
                            nextPage={`geracao/${bookId}`}
                            status={status}
                            etapa={3}
                            bookId={bookId}
                            history={props.history}
                            chamadaLivro={chamadaLivro}
                        />
                    )}
            </div>

            {loadingLivros ? (
                <div className="d-flex justify-content-center py-5">
                    <div className="spinner-border text-primary" role="status" />
                </div>
            ) : (
                <>
                    <div className="row no-gutters">
                        <div className="col-12 col-lg-6">
                            <div className="card mx-1">
                                <h3 className="m-3">ETAPA 3</h3>
                                <div className="row no-gutters px-3 mt-4">
                                    <div className="col-12 mb-3 px-2">
                                        <p className="pl-2"><strong>Título:</strong></p>
                                        <p className="pl-2">{livro.title}</p>
                                    </div>
                                    <div className="col-12 mb-3 px-2">
                                        <p className="pl-2"><strong>Subtítulo:</strong></p>
                                        <p className="pl-2">{livro.subtitle}</p>
                                    </div>

                                    <div className="col-12 col-lg-8 mb-3 px-2">
                                        <p className="pl-2"><strong>Autor:</strong></p>
                                        <p className="pl-2">{livro.author}</p>
                                    </div>

                                    <div className="col-12 col-lg-2 offset-lg-1 mb-5 px-2">
                                        <p className="pl-2"><strong>Versão:</strong></p>
                                        <p className="pl-2">{livro.version}</p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mx-1 mt-2">
                                <div className="row no-gutters px-3 mt-4">
                                    <div className="col-12 mb-3 px-2">
                                        <h5>Geração de EPUB</h5>
                                    </div>
                                    <div className="col-12 col-lg-8 mb-3 px-2">
                                        {loadingExtracao ?
                                            <div className="spinner-border text-info" role="status" />
                                            :
                                            <div className="d-flex align-items-center">
                                                {flagExtracao ?
                                                    <p className="mb-0 ml-3"><i className="py-2 fas fa-check text-primary"></i> Extração já realizada.</p>
                                                    :
                                                    <button className="btn btn-outline-info" disabled={status === 3} onClick={() => extrairConteudo()}>Extrair conteúdo</button>
                                                }
                                            </div>
                                        }
                                        <div className="d-flex align-items-center">
                                            <p className="m-0"><small className="pt-2">Extrair dados para compilação e criação do EPUB</small></p>

                                        </div>
                                        {loadingGeracao ?
                                            <div className="spinner-border text-primary" role="status" />
                                            :
                                            flagGeracao &&
                                            <div className="d-flex align-items-center">
                                                <button className="btn btn-outline-primary mt-4" disabled={status === 3} onClick={() => gerarLivro()}>Gerar EPUB</button>
                                            </div>
                                        }
                                        <div className="d-flex align-items-center">
                                            <p className="m-0"><small className="pt-2">Preparação final e publicação do livro em homologação.</small></p>

                                        </div>
                                    </div>

                                    {
                                        flagExtracao && (
                                            <div className="col-12 col-lg-4 mb-3 px-2 d-flex flex-column align-items-center justify-content-center">
                                                {loadingReverter ? (
                                                    <div className="spinner-border text-danger" role="status" />
                                                ) : (
                                                    <button className="btn btn-outline-danger mb-2" disabled={status === 3} onClick={() => toggleModalReverter()}>Reverter Extração</button>
                                                )}
                                                <p className="m-0"><small className="pt-2">Para gerar uma nova versão é necessário reverter a extração e fazer novamente.</small></p>

                                                <a href={`https://ebs-cile-digital-client-hml.appspot.com/livro/${bookId}`} target="_blank" rel="noopener noreferrer">
                                                    <button className="btn btn-outline-purple mt-4">Acessar livro</button>
                                                </a>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-6">
                            <div className="card mx-1">
                                <div className="row no-gutters px-3 mt-4">
                                    <div className="col-12 col-lg-12 mb-3">
                                        <p className="pl-2"><strong>Capítulos:</strong></p>


                                        <ul className="list-group mt-3">
                                            {livro.summaries.map((item, index) => (
                                                <li key={index} className="list-group-item  d-flex justify-content-between">
                                                    <div className="d-flex align-items-center">
                                                        <p className="m-0">{item.title}</p>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </>
            )}

            <Modal isOpen={modalInfosSuccess} toggle={toggleModalInfos}>
                <ModalHeader toggle={toggleModalInfos}>
                    Sucesso
                </ModalHeader>
                <ModalBody>
                    <p>Etapa realizada com sucesso!</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => { toggleModalInfos() }}>fechar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={modalReverter} toggle={toggleModalReverter}>
                <ModalHeader toggle={toggleModalReverter}>
                    Reverter EPUB
                </ModalHeader>
                <ModalBody>
                    <p>Tem certeza que deseja reverter a extração do EPUB?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => { toggleModalReverter() }}>fechar</Button>
                    {loadingReverter ?
                        <div className="spinner-border text-danger" role="status" /> :
                        <Button color="danger" disabled={loadingReverter} onClick={() => { reverterConteudo() }}>Confirmar</Button>
                    }
                </ModalFooter>
            </Modal>

            <ErrorModal
                isOpen={openErrorModal}
                message={errorMessage}
                closeErrorModal={() => { toggleErrorModal(); }}
            />

        </div >
    )
}


export default withRouter(CileContentEpubReview);